import React from "react";
import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  INLegsSearchParam,
  INLegsTableReport,
  INLegsTradeTableReport,
} from "../../../Interfaces/nLegsInterfaces";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  getNLegsTradeTable,
  getNLegTradeExcel,
} from "../../../Requests/nLegsRequests";
import FileDownloader from "../../../Components/FileDownloader";
import { useAppDispatch } from "../../../App/hooks";
import { onNLegsOrderFormValuesChange } from "../../../Features/NLegs/nLegsSlice";
import { Additional } from "./Additional";

interface IProps {
  searchParam: INLegsSearchParam;
  legCount: number;
}

const NLegsTradeTable = ({ searchParam, legCount }: IProps) => {
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: INLegsTradeTableReport) => {
    dispatch(
      onNLegsOrderFormValuesChange({
        name: "uNLegsItems",
        value: row.instrumentInfo,
      })
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table relative">
      <div className="w-8 cursor-pointer absolute top-0 -left-10">
        <FileDownloader getFile={() => getNLegTradeExcel(searchParam)} />
      </div>
      <TableTemplate<INLegsSearchParam, INLegsTradeTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={(
          sp,
          offset,
          pageSize,
          sortingType,
          additional,
          axiosOptions
        ) =>
          getNLegsTradeTable({
            legCount,
            offset,
            pageSize,
            searchParam: sp,
            sortingType,
            additional,
            axiosOptions,
          })
        }
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={tableRowClickHandler}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={Additional}
            tableBoxClassName="max-h-[500px] overflow-auto"
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default NLegsTradeTable;
